import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Field } from 'react-final-form';
import { RenderDropdown, validators } from 'forms';
import { AppState } from 'services/types';
import { selectMyTimesheetFilteredGroups } from './selectors';

interface ConnectedProps {
    options: ReturnType<typeof selectMyTimesheetFilteredGroups>;
}

interface OwnProps {
    personId: number;
}

type Props = OwnProps & ConnectedProps;

export class MyTimesheetGroupDropdownFieldComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { options } = this.props;

        return (
            <Field
                component={RenderDropdown as any}
                label="Group"
                name="groupId"
                options={options}
                placeholder="Select a group"
                clearable={false}
                fluid
                search
                selection
                validate={validators.isRequired}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    options: selectMyTimesheetFilteredGroups
});

export default connect(mapStateToProps)(MyTimesheetGroupDropdownFieldComponent);
